import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { Card, CardBody, CardTitle, Col, Container, Row } from "reactstrap";
import { User } from "../..";
import ResponseHandler from "../../../App/ResponseHandler";
import { useLoggedInUser } from "../../../Auth";
import { ApiRequest, ForbiddenDisplay, LoadingDisplay } from "../../../Common";
import { ResponseResult } from "../../../Common/Models/ResponseResult";
import FeedbackListContainer from "../../../Feedback/Components/Common/FeedbackList/FeedbackListContainer";
import { FeedbackSortOption } from "../../../Feedback/Constants/feedbackEnums";
import { endpoints } from "../../Constants/endpoints";

type TParams = {
  username: string;
};

export const UserAssignedFeedbacksContainer: React.FC = () => {
  const { username } = useParams<TParams>();
  const loggedInUser = useLoggedInUser();
  const [user, setUser] = useState<User | null>(null);

  // load the user we are viewing
  useEffect(() => {
    ApiRequest.fromPath(endpoints.users.getByUsername(username))
      .withAuthHeader()
      .get()
      .then(response => {
        ResponseHandler.handle(
          response,
          (result: ResponseResult<User>) => {
            setUser(result.payload);
          },
          result => {
            console.error(`Failed to load user: ${result.error.message}`);
          },
          () => {
            console.error("Failed to load user. An unknown error has occurred");
          }
        );
      });
  }, []);

  if (!user || !loggedInUser) {
    return <LoadingDisplay />;
  }

  const isCMUser =
    loggedInUser.profile.companyName &&
    loggedInUser.profile.companyName.toLowerCase() === "cadmakers";

  if (!isCMUser) {
    return (
      <ForbiddenDisplay description="You do not have access to feedback assignments for this user" />
    );
  }

  return (
    <Container fluid>
      <Row>
        <Col lg={10}>
          <h2>{(user as User).name} Assigned Feedbacks</h2>
        </Col>
      </Row>
      <br />
      <Row>
        <Card style={{ width: "100%" }}>
          <CardBody>
            <FeedbackListContainer
              listId={`APP_USER_PROFILE_ASSIGNED_FEEDBACKS_LIST${username}`}
              maxNumToGet={1000}
              sort={FeedbackSortOption.DateCreated}
              isAscending={false}
              reorderable
              assignedUsers={[user.id]}
              fullscreen
              enableDownload
            />
          </CardBody>
        </Card>
      </Row>
    </Container>
  );
};
